import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gold-500/20 last:border-0" data-id="element-1">
      <button className="w-full py-5 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-2">
        <span className={`text-lg md:text-xl font-medium transition-colors duration-300 ${isOpen ? 'text-gold-600' : 'text-charcoal group-hover:text-gold-600'}`} data-id="element-3">
          {title}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gold-600" data-id="element-4" /> : <ChevronDown className="w-5 h-5 text-charcoal/50 group-hover:text-gold-600" data-id="element-5" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-6">
        <div className="text-charcoal/70 font-light leading-relaxed text-base md:text-lg" data-id="element-7">
          {children}
        </div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
  allowMultiple?: boolean;
}
export function Accordion({
  items,
  allowMultiple = false
}: AccordionProps) {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const toggleItem = (index: number) => {
    if (allowMultiple) {
      setOpenIndexes(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
    } else {
      setOpenIndexes(prev => prev.includes(index) ? [] : [index]);
    }
  };
  return <div className="w-full max-w-3xl mx-auto" data-id="element-8">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndexes.includes(index)} onClick={() => toggleItem(index)} data-id="element-9">
          {item.content}
        </AccordionItem>)}
    </div>;
}